'use client';

/**
 * App-Store IAP compliance alert. Inside the CommentSold native app a purchase
 * must not proceed (external or native) — every purchase trigger surfaces this
 * alert instead. Mirrors legacy `flows/pdp/content.tsx` `setShowAlert(true)`.
 *
 * Rendered once by `PdpPurchaseProvider`, so BOTH the sticky CTA and the inline
 * digital-summary button share the single alert.
 */
export function AppUserPurchaseAlert({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  if (!open) return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-white p-5 text-center text-neutral-900 shadow-xl"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="text-body">Alert</h2>
        <p className="text-sub mt-2">
          You cannot purchase products directly from the app.
        </p>
        <button
          type="button"
          onClick={onClose}
          className="text-sub mt-4 w-full rounded-lg bg-neutral-900 px-4 py-2 text-white"
        >
          OK
        </button>
      </div>
    </div>
  );
}
